module.exports = __webpack_public_path__ + "static/media/skeleton.867a1cc7.png";